import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { deleteProductType } from "@tCentro/Services/CENAdminProductTypeService";

export interface DeleteProductTypeParameter extends HasOnSuccess<void>, HasOnError<string> {
    productTypeId: string;
}

type HandlerType = ApiHandler<DeleteProductTypeParameter, {}>;

export const DeleteProductType: HandlerType = async props => {
    try {
        await deleteProductType(props.parameter.productTypeId);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess();
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to delete product type");
        }
    }
};

export const chain = [DeleteProductType];
const deleteProductTypeData = createHandlerChainRunner(chain, "deleteProductTypeData");
export default deleteProductTypeData;
